import Vue from 'vue'

import { Services, getServiceNameViaPoint, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'

import { eventHandlers, globalErrorHandler, permissionPresets, request } from '@/utils'

import render from './render'

export default {
  name: 'Actions',

  mixins: [ eventHandlers ],

  props: {
    actions: {
      type: Array,
      default: () => {
        return [ 'edit', 'remove' ]
      },
      validator: value => {
        return value.every(action => {
          return [ 'edit', 'remove' ].includes(action)
        })
      }
    },

    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    service: {
      type: String,
      required: true,
      validator: value => {
        return Object.values(Services).includes(value)
      }
    },

    accept: {
      type: Array,
      default: () => {
        return permissionPresets.resellerUp
      }
    },

    editCallback: Function,
    removeCallback: Function
  },

  data() {
    return {
      loading: false,
      showMenu: false
    }
  },

  computed: {
    $_serviceViaPoint() {
      return getServiceNameViaPoint(this.service)
    },
    $_disabled() {
      if (
        this.checkPermissions(`advanced.${this.$_serviceViaPoint}.update`, this.accept) ||
        this.checkPermissions(`advanced.${this.$_serviceViaPoint}.remove`, this.accept) ||
        typeof this.$scopedSlots.default === 'function'
      ) {
        return false
      }

      return true
    }
  },

  methods: {
    async editClickHandler() {
      if (this.editCallback && typeof this.editCallback === 'function') {
        await this.editCallback()
      } else {
        Vue.router.push({
          name: `${this.$_serviceViaPoint}.single`,
          params: { id: this.value.id }
        })
      }
    },

    async remove() {
      if (this.checkPermissions(`advanced.${this.$_serviceViaPoint}.remove`, this.accept)) {
        try {
          if (this.removeCallback && typeof this.removeCallback === 'function') {
            await this.removeCallback()
          } else {
            this.loading = true
            const pathToAPI = getServicePathToAPI(this.service)
            await request.remove(joinURLPath(pathToAPI, this.value.id))
            this.addSnackbar({
              text: this.getTranslate(`${this.$_serviceViaPoint}.snackbars.removed`),
              type: 'warning'
            })
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading = false
        }
      }
    }
  },

  render
}
